import { create } from 'zustand';

const useUIStore = create((set, get) => ({
  // State
  sidebarOpen: true,
  theme: 'light',
  notifications: [],
  loading: false,
  error: null,
  
  // ADD: Mobile detection
  isMobile: false,

  // Command palette
  commandPaletteOpen: false,

  // Actions
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set(state => ({ sidebarOpen: !state.sidebarOpen })),
  
  setTheme: (theme) => set({ theme }),
  toggleTheme: () => set(state => ({ 
    theme: state.theme === 'light' ? 'dark' : 'light' 
  })),
  
  addNotification: (notification) => set(state => ({
    notifications: [...state.notifications, { 
      id: Date.now(), 
      timestamp: new Date(), 
      ...notification 
    }]
  })),
  
  removeNotification: (id) => set(state => ({
    notifications: state.notifications.filter(n => n.id !== id)
  })),
  
  clearNotifications: () => set({ notifications: [] }),
  
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
  
  // ADD: Mobile actions
  setIsMobile: (isMobile) => set({ isMobile }),

  // Command palette actions
  openCommandPalette: () => set({ commandPaletteOpen: true }),
  closeCommandPalette: () => set({ commandPaletteOpen: false }),
  toggleCommandPalette: () => set((state) => ({ commandPaletteOpen: !state.commandPaletteOpen })),
}));

export default useUIStore;